module.exports = __webpack_public_path__ + "img/Dashboard.3d3e6083.svg";